import {Component, EventEmitter, Input, Output} from '@angular/core';
import {VehicleBrand} from '../../../../domain/core/vehicle-brand.model';
import {CheckboxIconComponent} from '../../../../shared/components/checkbox-icon/checkbox-icon.component';
import {CustomerClientRequest} from '../../../../domain/data/customer-client-request.data';
import {ConsentStatus} from '../../../../domain/data/consent-status';

@Component({
    selector: 'app-profiling',
  imports: [
    CheckboxIconComponent,
  ],
    templateUrl: './profiling.component.html'
})
export class ProfilingComponent {
  @Input() brand: VehicleBrand
  @Input() customerConsentRequest: CustomerClientRequest;
  @Input() descriptionText: string;
  @Output() didChange = new EventEmitter<void>();

  textExpanded = false;

  protected readonly ConsentStatus = ConsentStatus;

  get clampedText(): string {
    if (this.textExpanded || this.descriptionText.length <= 180) {
      return this.descriptionText;
    }

    const words = this.descriptionText.slice(0, 180).split(' ');
    words.pop();
    return words.join(' ') + '...';
  }

  getProfilingIcon(icon: 'checked' | 'unchecked') {
    const profiling = this.customerConsentRequest?.profiling;
    const iconMappings = {
      checked: {
        condition: profiling === ConsentStatus.CONFIRMED,
        true: 'box-checked-green',
        false: 'box-checked-grey'
      },
      unchecked: {
        condition: profiling === ConsentStatus.WITHDRAWN,
        true: 'box-unchecked-red',
        false: 'box-unchecked-grey'
      }
    };
    const mapping = iconMappings[icon];
    return mapping ? (mapping.condition ? mapping.true : mapping.false) : undefined;
  }

  change(value: ConsentStatus) {
    this.customerConsentRequest.profiling = value;
    this.didChange.emit();
  }

  toggleExpand() {
    this.textExpanded = !this.textExpanded;
  }
}
